import { makeStyles } from '@material-ui/core/styles'
import failure from 'src/assets/Buy_Policy_Images/failure.svg'
import contact from 'src/assets/Buy_Policy_Images/contact.svg'
import { CONTACT, NOTIFICATION_TYPES } from 'src/utils/constants/common'
import React, { useCallback, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { scrollToTop } from 'src/utils/commonMethods'
import { getTokenForQrReport } from 'src/services/individualService'
import {
  fetchTokenForBuyPolicy,
  saveISNPStatus,
  updatePaymentInfo,
} from 'src/services/buyPolicyService'
import LoadingModal from 'src/components/common/LoadingModal'
import { useDispatch, useSelector } from 'react-redux'
import { showNotificationMessage } from 'src/actions'
import { getISNPStatusRequestBody } from 'src/utils/commonMethods/buyPolicy'
import {
  CURRENT_STATUS,
  ENCOUNTERED_ERROR_WHILE_SAVING,
  INSURANCE_TYPE_CATOGORIES,
  PAYMENT_STATUS,
} from 'src/utils/constants/BuyPolicy'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'

const PaymentFailure = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const { search } = useLocation()
  const searchParams = React.useMemo(
    () => new URLSearchParams(search),
    [search]
  )
  const policyNumber = searchParams.get('policyNumber')
  const transactionNumber = searchParams.get('transactionNumber')
  const guestUserDetails = useSelector((state) => state?.buyPolicyReducer)

  const updatePaymentStatus = useCallback(
    async (token) => {
      setLoading(true)
      const requestBody = {
        policyId: policyNumber,
        transactionNumber: transactionNumber,
        success: false,
      }

      try {
        const response = await updatePaymentInfo(token, requestBody)

        if (response?.res?.status !== 200) {
          setLoading(false)
          dispatch(
            showNotificationMessage({
              type: NOTIFICATION_TYPES?.ERROR,
              message:
                NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
            })
          )
          return // Exit early if the response is not successful
        }

        // Success
        const responseData = response?.res?.data
        setLoading(false) // Set loading to false after successful API call

        if (!responseData?.success) {
          // dispatch(                         // Future use
          //   showNotificationMessage({
          //     type: NOTIFICATION_TYPES?.ERROR,
          //     message: responseData?.message,
          //   })
          // )
        }
      } catch (err) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: PAYMENT_STATUS,
          })
        )
      }
    },
    [dispatch, policyNumber, transactionNumber]
  )

  const fetchToken = useCallback(async () => {
    setLoading(true)
    try {
      const response = await getTokenForQrReport()

      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
        return // Exit early if the response is not successful
      }

      // Success
      const token = response?.res?.data?.access_token
      updatePaymentStatus(token)
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
        })
      )
    } finally {
      setLoading(false) // Ensure loading is set to false in case of success or error
    }
  }, [dispatch, updatePaymentStatus])

  const saveISNPStatusTasks = useCallback(
    async (token) => {
      setLoading(true)
      const formData = getISNPStatusRequestBody(
        guestUserDetails,
        INSURANCE_TYPE_CATOGORIES?.health,
        CURRENT_STATUS?.paymentFailedKycPending
      )

      try {
        const response = await saveISNPStatus(token, formData)

        // This is the response which is coming from the backend.
        // The responseData is returned here and main logic as per requirements will be handled here

        setLoading(false) // Set loading to false after successful API call
        return response.res.data
        // Handle any additional logic with apiResponse if needed
      } catch (error) {
        // If there is any error from the backend it will be handled here
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: ENCOUNTERED_ERROR_WHILE_SAVING,
          })
        )
      }
    },
    [dispatch, guestUserDetails]
  )

  const saveMetadataAndNavigate = useCallback(() => {
    setLoading(true)

    Promise.resolve(fetchTokenForBuyPolicy())
      .then((token) => {
        setLoading(false)
        saveISNPStatusTasks(token)
      })
      .catch(() => {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
          })
        )
      })
  }, [dispatch, saveISNPStatusTasks])

  useEffect(() => {
    scrollToTop()
    fetchToken()
    saveMetadataAndNavigate()
  }, [fetchToken, saveMetadataAndNavigate])

  return (
    <div>
      <LoadingModal loading={loading} />
      <div className={classes.mainContainer}>
        <div className={classes.failureContainer}>
          <div className={classes.image}>
            <img src={failure} alt='failure' />
          </div>
          <div className={classes.headingContainer}>
            <div>
              <span className={classes.heading}>Something Went Wrong</span>
            </div>
            <div>
              <span className={classes.content}>
                Transaction ID: {transactionNumber}
              </span>
              {/* <span className={classes.content}> | 18-Aug-2023, 13:44</span>*/}
            </div>
          </div>
          <div>
            <span className={classes.screenshotContent}>Take a screenshot</span>
          </div>
        </div>
        <div className={classes.contactContainer}>
          <div>
            <span className={classes.callInput}>Call Us</span>&nbsp;
          </div>
          <div>
            <img src={contact} alt='' />
            &nbsp;
          </div>
          <div>
            <span className={classes.input}>24/7 Support</span>
            <br></br>
            <span className={classes.number}>{CONTACT?.Contact}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PaymentFailure
const useStyles = makeStyles({
  failureContainer: {
    background: 'linear-gradient( #EF669B -760%, #FFFFFF 100%)',
    border: 'none',
    width: '60%',
    padding: '30px 80px 30px 80px',
    boxShadow: '0px 6px 8px 0px #4DC3E333',
    borderRadius: '10px',
    position: 'relative',
  },
  mainContainer: {
    padding: '80px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    background: 'white',
  },
  contactContainer: {
    background: 'linear-gradient(0deg, #EBEBEB -33.33%, #FFFFFF 87.68% )',
    borderRadius: '5px',
    border: '1px solid #DCDCDC',
    display: 'flex',
    padding: '5px 18px',
    alignItems: 'center',
    height: '60px',
    marginTop: '-35px',
    zIndex: '1',
  },
  callInput: {
    fontSize: '16px',
    color: '#BBBBBB',
  },
  input: {
    fontSize: '13px',
    color: '#BBBBBB',
  },
  number: {
    fontSize: '18px',
  },
  headingContainer: {
    textAlign: 'center',
    padding: '40px',
  },
  image: {
    textAlign: 'center',
  },
  heading: {
    color: '#FF7761',
    fontSize: '27.5px',
  },
  content: {
    color: '#676767',
    fontSize: '14px',
  },
  screenshotContent: {
    color: '#CBAEAE',
    fontSize: '13px',
    position: 'absolute',
    bottom: '10px',
    left: '10px',
  },
})
